'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = delegate;

require('./matches.js');

// Self-executing

function delegate(Element, selector, type, listener) {
    Element.addEventListener(type, function (e) {
        for (var target = e.target; target && target != this; target = target.parentNode) {
            // loop parent nodes from the target to the delegation node
            if (target.matches(selector)) {
                listener.bind(target)(e);
                break;
            }
        }
    }, false);
}


//////////////////
// WEBPACK FOOTER
// ./~/kompo-util/lib/delegate.js
// module id = 20
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11